import { Skeleton } from '@ui/Skeleton';

interface Props {
  className?: string,
}

export const ProfileSocialPostsAsideSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={className}>
      <Skeleton
        width='100%'
        height='24px'
      />
      
      <Skeleton
        width='80%'
        height='24px'
      />
      <Skeleton
        width='100%'
        height='24px'
      />
      
      <Skeleton
        width='80%'
        height='24px'
      />
    </div>
  );
};
